module.exports = __webpack_public_path__ + "static/OldMansJourney1-d46f27f0e8ac4e5c1ee5cb9e5fa5bf14.webp";